import ProductDetail from "../../views/ProductDetail";

export default [
  {
    // path: "/product/dp/:id",
    // path: "/p/d/:id",
    // path: "/product/:id",
    path: "/:id",
    component: ProductDetail,
    props: true
  }
];
